document.querySelectorAll<HTMLInputElement>('input[data-typeahead]').forEach(inputEl => {
    const { apiRoute } = inputEl.dataset;

    if (!apiRoute) {
        return;
    }

    const inputTypeaheadId = `typeahead-${inputEl.dataset.typeahead || crypto.randomUUID()}`;
    inputEl.dataset.typeahead = inputTypeaheadId;

    const inputWrapper = document.createElement('div');
    inputWrapper.classList.add('typeahead-input-wrapper');

    // insert the wrapper to where the input element is
    inputEl.parentNode?.insertBefore(inputWrapper, inputEl);

    // move the input element inside the wrapper
    inputWrapper.appendChild(inputEl);

    const clearButton = document.createElement('div');
    clearButton.classList.add('typeahead__clear');
    clearButton.innerText = '✕';

    let selectedValue = inputEl.value;

    clearButton.addEventListener('click', () => {
        resetSelectedValue();
        updateInputElementValue(selectedValue)
        inputEl.focus();

        const hiddenInputs = inputEl.closest('.typeahead-input-wrapper')
            ?.parentElement?.querySelectorAll<HTMLInputElement>('.typeahead-input-wrapper ~ input[type="hidden"]');

        hiddenInputs?.forEach(hiddenInput => {
            hiddenInput.value = '';
            hiddenInput.dispatchEvent(new Event('change'));
        });
    });

    if (!selectedValue) {
        inputWrapper.classList.add('typeahead-input-wrapper__no-value');
    }

    inputWrapper.appendChild(clearButton);

    const dropdown = document.createElement('div');
    dropdown.classList.add('typeahead__results');
    dropdown.setAttribute('id', inputTypeaheadId);
    dropdown.style.display = 'none';

    document.body.appendChild(dropdown);

    let currentRequest: AbortController = new AbortController();
    let debounceTimeout: number = 0;
    inputEl.addEventListener('input', async () => {
        clearTimeout(debounceTimeout);

        if (currentRequest) {
            currentRequest.abort();
        }

        alignDropdown();
        dropdown.style.display = 'block';
        inputWrapper.classList.remove('typeahead-input-wrapper__no-value');

        dropdown.innerHTML = '<div class="typeahead__notfound">Fetching...</div>';

        debounceTimeout = setTimeout(async () => {
            currentRequest = new AbortController();

            const response = await fetch(
                `/api/${apiRoute}?searchText=${inputEl.value}`,
                { signal: currentRequest.signal }
            );
            const data: ResponseResult[] = await response.json();

            dropdown.innerHTML = '';
            
            data.forEach((item, index) => {
                const itemEl = document.createElement('div');
                itemEl.textContent = item.name;
                itemEl.classList.add('typeahead__result');
    
                const isFirstElement = index === 0;
                if (isFirstElement) {
                    itemEl.classList.add('typeahead__active-item');
                }
    
                itemEl.addEventListener('click', () => {
                    selectedValue = item.name;
                    updateInputElementValue(selectedValue);
    
                    for (const key in item.additionalValues) {
                        if (key === 'NavigateTo') {
                            location.href = item.additionalValues[key];
                        }
    
                        const hiddenInputEl = document.querySelector<HTMLInputElement>(`input[type="hidden"][name="${key}"]`);
                        
                        if (hiddenInputEl) {
                            hiddenInputEl.value = item.additionalValues[key];
                            hiddenInputEl.dispatchEvent(new Event('change'));
                        }
                    }
                    
                    const typeaheadSelectedEvent = new CustomEvent(
                        'typeaheadSelectedEvent',
                        {
                            detail: { updateInputElementValue, resetSelectedValue, selectedItem: item }
                        }
                    );
    
                    document.dispatchEvent(typeaheadSelectedEvent);
                });
    
                dropdown.appendChild(itemEl);
            });
    
            if (!data || data.length === 0) {
                const itemEl = document.createElement('div');
                itemEl.textContent = 'No Results Found';
                itemEl.classList.add('typeahead__notfound');
                dropdown.appendChild(itemEl);
            }
        }, 300);

        if (!inputEl.value) {
            dropdown.style.display = 'none';
            inputWrapper.classList.add('typeahead-input-wrapper__no-value');
        }
    });

    inputEl.addEventListener('keydown', (event) => {
        let activeItem = dropdown.querySelector<HTMLElement>('.typeahead__active-item')!;

        if (event.key === 'Enter') {
            event.preventDefault();

            if (activeItem) {
                inputEl.blur();
                activeItem.click();
            }
        }

        if (event.key === 'ArrowDown') {
            activeItem.classList.remove('typeahead__active-item');

            activeItem = (activeItem.nextElementSibling || activeItem.parentElement!.firstElementChild) as HTMLElement;

            activeItem.classList.add('typeahead__active-item');
        }

        if (event.key === 'ArrowUp') {
            activeItem.classList.remove('typeahead__active-item');

            activeItem = (activeItem.previousElementSibling || activeItem.parentElement!.lastElementChild) as HTMLElement;

            activeItem.classList.add('typeahead__active-item');
        }
    });

    window.addEventListener('resize', alignDropdown);

    document.addEventListener('click', (event) => {
        if (!inputEl.contains(event.target as Node) || !dropdown.contains(event.target as Node)) {
            inputEl.value = selectedValue;

            if (selectedValue) {
                inputWrapper.classList.remove('typeahead-input-wrapper__no-value');
            } else {
                inputWrapper.classList.add('typeahead-input-wrapper__no-value');
            }

            dropdown.style.display = 'none';
        }
    });

    function alignDropdown() {
        const rect = inputEl.getBoundingClientRect();
        dropdown.style.top = `${rect.bottom + window.scrollY}px`;
        dropdown.style.left = `${rect.left + window.scrollX}px`;
        dropdown.style.width = `${rect.width}px`;
    };

    function updateInputElementValue(value: string) {
        inputEl.value = value;
        inputEl.dispatchEvent(new Event('input'));
    }

    function resetSelectedValue() {
        selectedValue = '';
    }
});

document.querySelectorAll<HTMLInputElement>('input[data-typeahead][data-typeahead-with-tags]').forEach(inputEl => {
    let typeaheadTagsWrapper: HTMLElement;
    let selectedValues: any[] = [];
    const typeaheadInputWrapper = inputEl.closest('.typeahead-input-wrapper');

    if (typeaheadInputWrapper?.nextElementSibling?.classList.contains('typeahead-selected-list')) {
        typeaheadTagsWrapper = typeaheadInputWrapper?.nextElementSibling as HTMLElement;
        selectedValues = JSON.parse(typeaheadTagsWrapper.dataset.selectedSuburbs!);
        updateTypeaheadTags();
    }

    document.addEventListener('typeaheadSelectedEvent', (event) => {
        const customEvent = event as CustomEvent<TypeaheadSelectedEvent>;

        if (typeaheadTagsWrapper) {
            const { selectedItem, resetSelectedValue, updateInputElementValue } = customEvent.detail;

            if (!selectedValues.some(x => [x.name, x.Name].includes(selectedItem.name))) {
                selectedValues.push(selectedItem);
                updateTypeaheadTags();
            }

            if (selectedValues.length === 3) {
                inputEl.setAttribute('disabled', 'disabled');
            }

            resetSelectedValue();
            updateInputElementValue('');
        }
    });

    function handleRemoveTypeaheadTagEvent() {
        if (!typeaheadTagsWrapper) {
            return;
        }

        typeaheadTagsWrapper.querySelectorAll<HTMLElement>('.typeahead-remove').forEach(removeEl => {
            removeEl.addEventListener('click', () => {
                selectedValues = selectedValues.filter(selected =>
                    ![selected.name, selected.Name].filter(Boolean).includes(removeEl.dataset.elementToRemove)
                );
                updateTypeaheadTags();
                inputEl.removeAttribute('disabled');
            });
        });
    }

    function updateTypeaheadTags() {
        if (!typeaheadTagsWrapper) {
            return;
        }

        typeaheadTagsWrapper.innerHTML = '';

        selectedValues.forEach((item, index) => {
            let tagTemplateString = document.querySelector<HTMLTemplateElement>('template#typeaheadSelectedItem')?.innerHTML || '';

            if (!tagTemplateString) {
                return;
            }

            const name = item.name || item.Name;
            const slug = item.additionalValues?.CurrentSuburbSlug || item.AdditionalValues?.CurrentSuburbSlug;
            const state = item.additionalValues?.CurrentSuburbState || item.AdditionalValues?.CurrentSuburbState;
            const postalcode = item.additionalValues?.CurrentSuburbPostalCode || item.AdditionalValues?.CurrentSuburbPostalCode;
            
            tagTemplateString = tagTemplateString
                .replace(/{{text}}/g, name)
                .replace(/{{index}}/g, String(index))
                .replace(/{{CurrentSuburbSlug}}/g, slug)
                .replace(/{{CurrentSuburbState}}/g, state)
                .replace(/{{CurrentSuburbPostalCode}}/g, postalcode);
    
            typeaheadTagsWrapper.innerHTML += tagTemplateString;
    
            handleRemoveTypeaheadTagEvent();
        });
    }
});

interface AdditionalValues {
    [key: string]: string;
}

interface ResponseResult {
    name: string;
    value: string;
    additionalValues: AdditionalValues;
}

interface TypeaheadSelectedEvent {
    resetSelectedValue: () => void;
    updateInputElementValue: (value: string) => void;
    selectedItem: ResponseResult;
}